"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var contests_core_1 = require("@biw/contests-core");
var contests_constants_1 = require("@biw/contests-constants");
var EMPTY_ARRAY = [];
function getGoalSelectedProps(state, program) {
    var programViewId = program.programViewId;
    var progressModel = contests_core_1.progress.selectors.getProgress(state, programViewId) || {};
    var goalLevels = progressModel.goalLevels || EMPTY_ARRAY;
    var isHighestGoal = goalLevels.length === goalLevels.indexOf(progressModel.selectedGoal) + 1;
    return {
        tileType: 'goal-selected',
        /* footer*/
        buttonTextCode: program.isObjectives ? contests_constants_1.KEY_CODES.setyourplan : contests_constants_1.KEY_CODES.changegoal,
        footerMessageCode: isHighestGoal ? contests_constants_1.KEY_CODES.waytopush : contests_constants_1.KEY_CODES.pushyourself,
        levelName: get_1.default(progressModel, 'selectedGoal.name'),
        goalLabel: get_1.default(progressModel, 'goalOverview.goalLabelProps'),
        /*countdown*/
        daysLeft: program.daysLeft,
        calendarLabel: program.canSelectGoal ? 'goalSelection.toChangeGoal' : 'progress.daysToEarnLabel',
        lastDayLeftDate: program.lastDayLeftDate
    };
}
exports.default = getGoalSelectedProps;
//# sourceMappingURL=goal-selected-props.js.map